import { useEffect, useState } from "react";
import {
  Container,
  Title,
  Accordion,
  Text,
  Checkbox,
  Anchor,
  Select,
} from "@mantine/core";
import "react-phone-input-2/lib/style.css";
import classes from "../Screens/RegisterHero.module.css";
import { getRules, setRulesRead } from "../misc/api";

export const AirplaneRules = ({
  setAgreeChecked,
  agreeChecked,
  showRules = true,
  style,
  showCheckmark,
}) => {
  const [rules, setRules] = useState();
  const [cx, setCx] = useState(false);
  const [lng, setLng] = useState("en");

  useEffect(() => {
    getRules().then((x) => {
      setRules(x.data);
    });
  }, []);

  const userReadRulesAndAgreed = () => {
    if (window.confirm(lng == 'en' ? "Did you read the rules and agree to follow them?" : "Vai jūs izlasījāt noteikumus un piekrītat tos ievērot?")) {
      setCx(true);
      setRulesRead();
      window.location.href = "/main";
    }
  };

  return (
    <Container size="sm" className={classes.wrapper} style={style}>
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            paddingBottom: 20,
            // marginTop: -40,
          }}
        >
          <Select
            size="xs"
            style={{ maxWidth: 200 }}
            label={"Select rule language"}
            onChange={(e) => setLng(e ? e : "en")}
            value={lng ? lng : "en"}
            data={[
              { label: "Latviski", value: "lv" },
              { label: "English", value: "en" },
            ]}
            clearable={false}
          />
        </div>
        <Title ta="center" className={classes.title}>
          {
            lng === 'en' ? " Spilve airport Rules" : "Spilves lidostas lietošanas noteikumi"
          }

        </Title>
        <Text
          c="dimmed"
          mt="md"
          style={{ textAlign: "center", marginBottom: 20 }}
        >
          {lng === 'en' ? "Please read carefully and get acquainted with the rules." : "Lūdzu, rūpīgi izlasiet un iepazīstieties ar noteikumiem."}
        </Text>
      </div>
      {lng == 'en' ? <Title ta="center" style={{ fontSize: 14, marginBottom: 20 }}>
        To read full Spilve information and Rules please follow{" "}
        <Anchor href="https://ais.lgs.lv/aiseaip" target="_blank">
          this link to Latvia AIP online version
        </Anchor>
      </Title> :
        <Title ta="center" style={{ fontSize: 14, marginBottom: 20 }}>
          Lai iepazītos ar pilnu Spilves informāciju un noteikumiem, lūdzu, sekojiet{" "}
          <Anchor href="https://ais.lgs.lv/aiseaip" target="_blank">
            šai saitei uz Latvijas AIP tiešsaistes versiju
          </Anchor>
        </Title>
      }
      <Accordion variant="separated">
        {rules &&
          rules?.map((rule) => (
            <Accordion.Item className={classes.item} value={rule.id.toString()}>
              <Accordion.Control>{rule[`title_${lng}`]}</Accordion.Control>
              <Accordion.Panel>
                <div
                  dangerouslySetInnerHTML={{ __html: rule[`content_${lng}`] }}
                ></div>
              </Accordion.Panel>
            </Accordion.Item>
          ))}
      </Accordion>
      {showRules && (
        <strong>
          <Checkbox
            style={{ marginTop: 20 }}
            label={lng == "en" ? "I have read the aerodrome usage rules and will strictly comply" : "Esmu iepazinies ar lidlauka lidojumu noteikumiem un stingri tiem sekošu"}
            checked={agreeChecked}
            onChange={(event) => setAgreeChecked(event.currentTarget.checked)}
          />
        </strong>
      )}
      {showCheckmark && (
        <strong>
          <Checkbox
            style={{ marginTop: 20 }}
            label={lng == "en" ? "I have read the aerodrome usage rules and will strictly comply" : "Esmu iepazinies ar lidlauka lidojumu noteikumiem un stingri tiem sekošu"}
            checked={cx}
            onChange={(event) => userReadRulesAndAgreed()}
          />
        </strong>
      )}
    </Container>
  );
};
